<template>
  <div>
    <el-dialog
      :title="title"
      :visible.sync="dialogVisible"
      width="40%"
      :before-close="handleClose"
      :close-on-click-modal="false"
    >
      <validation-observer v-slot="{ invalid, handleSubmit }">
        <form
          @submit.prevent="handleSubmit(onSubmit)"
          class="tw-flex tw-flex-col tw-gap-4"
        >
          <div>
            <validation-provider
              name="drug"
              rules="required"
              v-slot="{ dirty, invalid, errors }"
            >
              <label for="">User</label>
              <v-select
                @search="getItems"
                v-model="payload.user"
                :options="items"
                label="first_name"
                :reduce="(item) => item.id"
                :class="{
                  error: dirty && invalid,
                }"
                placeholder="Select User"
              >
                <template slot="no-options"> Type to search.. </template>
                <template #open-indicator="{ attributes }">
                  <span v-bind="attributes"
                    ><i-icon
                      icon="radix-icons:caret-down"
                      color="#4F4F4F"
                      width="18px"
                  /></span>
                </template>
                <template #option="{ first_name, last_name }">
                  <span>{{ first_name }} {{ last_name }}</span>
                </template>
                <template #selected-option="{ first_name, last_name }">
                  <span>{{ first_name }} {{ last_name }}</span>
                </template>
              </v-select>
              <span class="tw-text-xs tw-text-error" v-if="errors">{{
                errors[0]
              }}</span>
            </validation-provider>
          </div>

          <div>
            <validation-provider
              name="hospital"
              rules="required"
              v-slot="{ dirty, invalid, errors }"
            >
              <label for="">Hospital</label>
              <v-select
                @search="searchHospitals"
                v-model="payload.hospital"
                :options="hospitals"
                :reduce="(item) => item.id"
                label="name"
                :class="{
                  error: dirty && invalid,
                }"
                placeholder="Select Hospital"
              >
                <template slot="no-options"> Type to search.. </template>
                <template #open-indicator="{ attributes }">
                  <span v-bind="attributes"
                    ><i-icon
                      icon="radix-icons:caret-down"
                      color="#4F4F4F"
                      width="18px"
                  /></span>
                </template>
              </v-select>
              <span class="tw-text-xs tw-text-error" v-if="errors">{{
                errors[0]
              }}</span>
            </validation-provider>
          </div>

          <span
            v-if="!viewMode"
            slot="footer"
            class="dialog-footer tw-flex tw-gap-2 tw-justify-center"
          >
            <button
              class="veo-btn veo-primary"
              :disabled="invalid"
              :class="{ 'tw-bg-gray-400': invalid || busy }"
            >
              {{ editMode ? "Edit" : "Create New" }}
            </button>
          </span>
        </form>
      </validation-observer>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    viewMode: {
      type: Boolean,
      default: false,
    },
    editMode: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: "",
    },
    item: {
      type: Object,
      default: () => {},
    },
    code_type : {
      type: String,
      default: "referral_code"
    }
  },
  data() {
    return {
      dialogVisible: false,
      items: [],
      hospitals: [],
      payload: {
        user: null,
        hospital: null,
      },
      busy: false,
    };
  },
  methods: {
    onSubmit() {
      let formData = new FormData();
      formData.append("user_id", this.payload.user);
      formData.append("hospital_id", this.payload.hospital);
      this.busy = true;
      this.$inventory
        .generateCode(formData, this.code_type)
        .then((res) => {
          let resPayload = res.data
          const new_value = this.code_type.split('_').join(' ')
          this.$toastify({
            text: `${new_value} created successfully`,
            className: "info",
            style: {
              background: "#333",
              fontSize: "12px",
              borderRadius: "5px",
            },
          }).showToast();
          this.busy = false;
          this.$emit("endGenerate", resPayload);
        })
        .catch((err) => {
          this.busy = false;
          return err
        });
    },

    handleClose() {
      this.$emit("handleClose");
    },

    getItems(search, loading) {
      let payload = { search: search };
      loading(true);
      this.$users
        .searchEnrollees(payload)
        .then((res) => {
          this.items = res.data;
        })
        .catch((err) => {
          return err
        })
        .finally(() => {
          loading(false);
        });
    },

    searchHospitals(search, loading) {
      let payload = { name: search };
      loading(true);
      this.$users
        .searchHospitals(payload)
        .then((res) => {
          this.hospitals = res.data;
        })
        .catch((err) => {
          return err
        })
        .finally(() => {
          loading(false);
        });
    },
  },

  watch: {
    visible: {
      handler(val) {
        this.dialogVisible = val;
      },
      immediate: true,
    },
  },
};
</script>

<style></style>
